export default "__VITE_ASSET__DMpF2bEB__"